import moment from "moment";
import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { headers, insertUpdateExhibitionFeildUrl, getExhibitionFeildDetailsUrl, INSERT_UPDATE_DELEGATE_EXHIBITION_FEILD_ACTION_TYPE, GET_DELEGATE_EXHIBITION_FEILD_ACTION_TYPE } from "../../../utils/constants";


export const insertUpdate_ExhibitionFeild_action = (ExhibitionID, AccountTypeID, ExhibitionFeildList) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            AccountTypeID: AccountTypeID,
            ExhibitionFeildList: ExhibitionFeildList,
        }

        const res = await axiosPost(insertUpdateExhibitionFeildUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_DELEGATE_EXHIBITION_FEILD_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getExhibitionFeild_action = (ExhibitionID, AccountTypeID) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            AccountTypeID: AccountTypeID,
        }

        const res = await axiosGet(getExhibitionFeildDetailsUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_EXHIBITION_FEILD_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}